import React from 'react'
import ReportList from './ReportList'

const Report = () => {
  return (
    <div>
      <ReportList/>
    </div>
  )
}

export default Report